import type { SupplierCertificate } from '@tandemone/types'

import {
  type CertificatesGalleryTracking,
  CertificatesGallery
} from './certificates-gallery'
import type { DocumentDownloadResult } from './document-preview-dialog'
import { ProfileEmpty } from './profile-empty'
import { ProfileSection } from './profile-section'

/** the supplier profile card wrapper. body lives in CertificatesGallery so the
 * company's own Certificates page and the super review queue can reuse the
 * carousel + table + preview without this section chrome.
 */
export function ProfileCertifications({
  companyName,
  certificates,
  fetchUrl,
  tracking,
  collapsible,
  defaultOpen
}: {
  companyName: string
  certificates: SupplierCertificate[]
  fetchUrl: (documentId: string) => Promise<DocumentDownloadResult>
  tracking?: CertificatesGalleryTracking
  collapsible?: boolean
  defaultOpen?: boolean
}) {
  return (
    <ProfileSection title={`${companyName} Certifications`}>
      <CertificatesGallery
        certificates={certificates}
        fetchUrl={fetchUrl}
        tracking={tracking}
        collapsible={collapsible}
        defaultOpen={defaultOpen}
        emptyState={<ProfileEmpty message='No certifications uploaded.' />}
      />
    </ProfileSection>
  )
}
